module.exports = __webpack_public_path__ + "static/media/shortlink3.3597d90b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/views/Tutorial/screenshots/Creating/shortlink3.jpg
// module id = 1620
// module chunks = 0